import {
  parseToSequence,
  TextOrMentionElement,
} from 'clerk_common/collaboration/mentions/parse';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import {
  MARKDOWN_COMPONENTS,
  MESSAGE_MARKDOWN_CLASSES,
} from './markdownComponents';

export function MessageMarkdown({
  message,
  className,
}: {
  message: string;
  className?: string;
}) {
  return (
    <div className={`${MESSAGE_MARKDOWN_CLASSES} ${className ?? ''}`}>
      <ReactMarkdown
        components={MARKDOWN_COMPONENTS}
        disallowedElements={['img']}
        remarkPlugins={[remarkGfm, remarkBreaks]}
      >
        {replaceMentionsWithBoldText(message)}
      </ReactMarkdown>
    </div>
  );
}

function replaceMentionsWithBoldText(text: string): string {
  return parseToSequence(text)
    .map((element: TextOrMentionElement) =>
      element.elementType === 'mention'
        ? `**@${escapeMarkdownText(element.display || element.id)}**`
        : element.text
    )
    .join('');
}

function escapeMarkdownText(text: string): string {
  return text.replace(/([\\`*_{}[\]()#+\-.!|~>:])/g, '\\$1');
}
